import React, { useState } from 'react';

import ShowProfileModal from '../../DashboardFileManagement/CardDetail/ShowProfileModal';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import { useHistory } from 'react-router-dom';
import SettingAboutForm from './SettingAboutForm';

// Styles
import styles from "./../Settings.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";

const SettingAbout = () => {
    const [modalShow, setModalShow] = useState(false);
    const history = useHistory();


    return (
        <>
            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
                            <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                            <div
                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                dir="rtl"
                            >
                                <div className='d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                    <a href='#' onClick={history.goBack}><img className='ms-2 pointer' src={arrowIcon} alt="icon" /></a>
                                    <div className={styles.text1}>
                                        درباره ما
                                    </div>
                                </div>
                            </div>

                            {/* About Form Details */}
                            <SettingAboutForm />


                        </div>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
        </>
    )

}

export default SettingAbout